
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import type { JobStatus, TrustStatus, PaymentStatus } from "@/lib/types";

export function JobStatusBadge({ status }: { status: JobStatus }) {
  const { t } = useTranslation();
  return (
    <Badge
      variant="outline"
      className={cn(
        "border-none font-medium",
        `status-${status}`
      )}
    >
      {t(`jobStatus.${status}`)}
    </Badge>
  );
}

export function TrustBadge({ status }: { status: TrustStatus }) {
  const { t } = useTranslation();
  const map: Record<TrustStatus, { labelKey: string; cls: string }> = {
    none: { labelKey: "trust.notSubmitted", cls: "bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400" },
    pending: { labelKey: "trust.pending", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300" },
    verified: { labelKey: "common.verified", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300" },
    rejected: { labelKey: "trust.rejected", cls: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300" },
  };
  const m = map[status] || map.none;
  return <span className={cn("inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium", m.cls)}>{t(m.labelKey)}</span>;
}

export function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
  const { t } = useTranslation();
  const map: Record<PaymentStatus, { labelKey: string; cls: string }> = {
    pending: { labelKey: "paymentStatus.pending", cls: "bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400" },
    collected: { labelKey: "paymentStatus.collected", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300" },
    confirmed: { labelKey: "paymentStatus.confirmed", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300" },
    failed: { labelKey: "paymentStatus.failed", cls: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300" },
  };
  const m = map[status] || map.pending;
  return <span className={cn("inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium", m.cls)}>{t(m.labelKey)}</span>;
}
